export const AUTH_ROUTES = {
  GOOGLE_START: "/api/auth/google",
  REFRESH: "/api/auth/refresh",
  LOGOUT: "/api/auth/logout",
} as const;

/** Reasons the login page can show after a failed Google sign-in (`/login?error=`). */
export const LOGIN_ERROR_CODES = [
  "google_unavailable",
  "google_denied",
  "invalid_state",
  "email_not_verified",
  "login_failed",
] as const;
export type LoginErrorCode = (typeof LOGIN_ERROR_CODES)[number];

export const DEFAULT_POST_LOGIN_PATH = "/library";
